import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  style: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
};

const defaultProps = {
  style: {},
  width: '18',
  height: '18',
};

const Drop = ({ style, width, height }) => {
  const defaultStyle = {
    fill: 'currentColor',
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <g fillRule="evenodd">
        <path
          stroke="#4A4A4A"
          d="M13.626 10.877a6.259 6.259 0 0 1-12.518 0c0-3.456 6.259-9.976 6.259-9.976s6.26 6.52 6.26 9.976"
        />
        <path
          fill="#4A4A4A"
          d="M11.346 11.24a3.927 3.927 0 0 1-7.853 0c0-2.168 3.926-6.26 3.926-6.26s3.927 4.092 3.927 6.26"
        />
      </g>
    </svg>
  );
};

<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" />;

Drop.propTypes = propTypes;
Drop.defaultProps = defaultProps;

export default Drop;



// WEBPACK FOOTER //
// ../ui-components/components/MenuItemIcon/Drop.jsx